import { HardDrive } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const HardDriveIcon = createLucideIcon(HardDrive);
